import { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { ClientOnly } from "shared/components/ClientOnly";
import { parseImagesModule } from "shared/utils/utils.js";
export const Page = () => {
    const [images, setImages] = useState([]);
    useEffect(() => {
        const modules = import.meta.glob('../../images/technicalSolutions/RPA/*.{png,jpg,jpeg,webp,avif}', {
            eager: true,
            import: 'default'
        })
        const images = parseImagesModule(modules)
        images.sort((i1, i2) => +i1.name.replace('Page', '') - +i2.name.replace('Page', ''))
        setImages(images)
    }, [])
    const settings = {
        dots: true,
    };
    const renderImage = (src, i) => {
        if (src?.jpg || src?.png) {

            return <picture
                style={{

                }}
                className="parameters__image">
                <source

                    srcSet={src.avif}
                    type="image/avif" />
                <img
                    loading={i !== 0 ? 'lazy' : 'eager'}
                    src={src?.jpg || src?.png}
                    style={{ width: '100%' }}
                    alt="слайды презентаций"
                    key={i}
                />
            </picture>
        }
        return (
            <img
                src={src}
                alt="слайды презентаций"
                key={i}
                className="parameters__image"
            />

        )
    }

    const renderFallback = () => {
        const defaultImg = images[0]
        if (!defaultImg) {
            return <></>
        }
        return renderImage(images[0], 0)
    }

    return <Layout >
        <div className="container">
            <div className="article-container ">
                <h1 className="mb-4 ">
                    NPT RPA Monitor
                </h1>
                <p >
                    <b>NPT RPA Monitor</b> - автоматизированная система мониторинга релейной защиты и автоматики электрических подстанций NPT RPA Monitor (АСМ РЗА) – (далее - NPT RPA Monitor) предназначена для постоянного мониторинга состояния устройств и комплексов РЗА, АСУ ТП, средств измерений, выполнения связанных с их функционированием расчетно-аналитических задач, а также для передачи данных мониторинга на верхний уровень АСМ и в диспетчерские центры АО «СО ЕЭС» по протоколу ССНТИ согласно ГОСТ Р 59550-2021 "Единая энергетическая система и изолированно работающие энергосистемы. Релейная защита и автоматика. СБОР, ХРАНЕНИЕ И ПЕРЕДАЧА В ДИСПЕТЧЕРСКИЕ ЦЕНТРЫ В АВТОМАТИЧЕСКОМ РЕЖИМЕ ФАЙЛОВ С ДАННЫМИ РЕГИСТРАЦИИ АВАРИЙНЫХ СОБЫТИЙ".
                </p>
                <p>
                    NPT RPA Monitor зарегистрирован в <a className="text-links" href="https://reestr.digital.gov.ru/reestr/2757888/" target="_blank">реестре отечественных программ Минцифры</a>.
                </p>
                <div className="mb-5 d-flex justify-content-center w-100" >
                    <div className=" w-100"
                        style={{ maxWidth: '80vw' }}>
                        <ClientOnly
                            fallback={renderFallback}
                            props={settings}
                            component={() => import("react-slick")}
                        >
                            {images.map(renderImage)}
                        </ClientOnly>
                    </div>

                </div>

                <p>Способы применения NPT RPA Monitor:</p>

                <ul className="mb-4 description__list">
                    <li className="mb-1 description__number-li">При установке на объектах электроэнергетики, NPT RPA Monitor применяется для автоматизированного сбора, обработки и передачи файлов с данными РАС и событий мониторинга устройств РЗА, АСУ ТП, СИ на верхний уровень АСМ. </li>
                    <li className="mb-1 description__number-li">При установке на верхнем уровне АСМ, NPT RPA Monitor применяется для передачи файлов с данными РАС в диспетчерские центры АО «СО ЕЭС». </li>
                </ul>
                <p>Функции NPT RPA Monitor делятся на две группы:</p>
                <ul className="mb-4 description__list">
                    <li className="mb-1 description__number-li">Функции уровня объекта электроэнергетики:
                        <ul>
                            <li>автоматизированный сбор файлов устройств РЗА, АСУ ТП и СИ, включая осциллограммы аварийных событий, журналы срабатывания микропроцессорных устройств РЗА, файлы параметрирования, тестовые отчеты об аварийных событиях автономных регистраторов аварийных событий, файлы с результатами ОМП на ЛЭП из устройств напрямую, а также из смежных информационных систем, выступающих источниками данных;</li>
                            <li>автоматизированный сбор и буферизация событий мониторинга устройств РЗА, АСУ ТП и СИ из устройств напрямую, а также из смежных информационных систем, выступающих источниками данных;</li>
                            <li>привязка файлов и событий мониторинга устройств РЗА, АСУ ТП и СИ к уникальным идентификаторам системы верхнего уровня АСМ;</li>
                            <li>передача данных на верхний уровень АСМ и (или) в диспетчерские центры АО «СО ЕЭС» по протоколу ССНТИ согласно ГОСТ Р 59550-2021 "Единая энергетическая система и изолированно работающие энергосистемы. Релейная защита и автоматика СБОР, ХРАНЕНИЕ И ПЕРЕДАЧА В ДИСПЕТЧЕРСКИЕ ЦЕНТРЫ В АВТОМАТИЧЕСКОМ РЕЖИМЕ ФАЙЛОВ С ДАННЫМИ РЕГИСТРАЦИИ АВАРИЙНЫХ СОБЫТИЙ";</li>
                            <li>визуализация оборудования объекта электроэнергетики с использованием моделей сети и оборудования электрических подстанций по ГОСТ Р 58651 «Единая энергетическая система и изолированно работающие энергосистемы. Информационная модель электроэнергетики»;</li>
                            <li>классификация событий мониторинга устройств РЗА, АСУ ТП и СИ по группам тревог и ведение журнала тревог;</li>
                            <li>ведение ведомости событий с отображением уведомлений о появлении новых файлов, изменении состояний событий мониторинга устройств РЗА, АСУ ТП и СИ, событий об отправке уведомлений на верхний уровень АСМ, событий отправки файлов на верхний уровень АСМ;</li>
                            <li>мониторинг каналов связи с верхним уровнем АСМ или с диспетчерскими центрами АО «СО ЕЭС»;</li>
                            <li>мониторинг каналов связи с устройствами или со смежными информационными системами, выступающими источниками данных;</li>
                            <li>загрузка конфигурации, сформированной на верхнем уровне АСМ;</li>
                            <li>формирование отчетов по результатам мониторинга устройств РЗА АСУ ТП и СИ на объекте электроэнергетики;</li>
                            <li>функции администрирования.</li>
                        </ul>
                    </li>
                    <li className="mb-1 description__number-li">
                        Функции верхнего уровня АСМ, которые доступны при установке NPT RPA Monitor совместно с ПО верхнего уровня АСМ на базе ПО <a href="https://npt-platform.ru/" target="_blanck"><b>NPT Platform</b></a>  ):
                        <ul>
                            <li>ведение базы данных оборудования электрических подстанций;</li>
                            <li>визуализация файлов, полученных с объекта электроэнергетики, с привязкой к устройствам РЗА, АСУ ТП и СИ;</li>
                            <li>анализ технического состояния устройств РЗА, АСУ ТП и СИ;</li>
                            <li>формирование рекомендаций по результатам мониторинга устройств РЗА, АСУ ТП и СИ;</li>
                            <li>контроль изменения уставок и конфигураций устройств РЗА;</li>
                            <li>автоматическая регистрация технологических нарушений на электрических подстанциях;</li>
                            <li>отображение и анализ осциллограмм аварийных событий;</li>
                            <li>анализ функционирования устройств (комплексов), функций РЗА и определение места повреждения на ЛЭП;</li>
                            <li>уведомление пользователей.</li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </Layout>
}
